import React from 'react';

import {
    NavLink,
    Link
} from 'react-router-dom'

import SlideUpDownNav from './../inc/SlideUpDownNav';

import SwiperCore, { Navigation, Autoplay, A11y, EffectFade } from 'swiper';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/swiper-bundle.css';

class Quote extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let _this = this;
        let { data } = this.props.press;
        let { ml_press } = this.props;
       
        return (
            <section className="section" id="press" data-logo="hide">
                <div className="mole__about--content-slides fullW">
                    <div className="main-container">
                        <div className="inner-container">
                            <h3 className="font-lg-head c-general mb-0">Press</h3>

                         
                            <Swiper
                                touchRatio={false}
                                navigation={{
                                    prevEl: '#press--swiper-hero--prev',
                                    nextEl: '#press--swiper-hero--next',
                                }}
                                slidesPerView={3} // or 'auto'
                                slidesPerColumn={5}
                                slidesPerGroup={3}
                                spaceBetween={25}
                                slidesPerColumnFill="row"
                                
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1
                                    },
                                    560: {
                                        slidesPerView: 2,
                                        spaceBetween: 25
                                    },
                                    1100: {
                                        slidesPerView: 4,
                                        spaceBetween: 25
                                    }
                                }}
                            >
                                {
                                    Object.keys(data).reverse().map((year, key) => {
                                        let press_year = data[year];
                                        return (
                                            
                                            press_year.map((article, index) => {
                                                return (
                                                    <SwiperSlide>
                                                    <div className="grid-item">
                                                        <p dangerouslySetInnerHTML={{__html:article.post_title}} />
                                                        <p>{article.press_category}</p>
                                                        <p>{article.month}</p>
                                                        
                                                        {article.pdf && article.pdf.url &&
                                                            <a className="c-hvr-general" href={article.pdf.url} target="_blank">{article.pdf_button_text}</a>
                                                        }
                                                        {!article.pdf.url &&
                                                            <p>&nbsp;</p>
                                                        }
                                                    </div>
                                                    </SwiperSlide>
                                                )
                                            })
                                           
                                        )
                                        
                                    })
                                }

                                {/* swiper arw */}
                                <div className="swiper-nav">
                                    <span className="swiper-hero--prev" id="press--swiper-hero--prev">
                                        <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                            <polygon points="4.7,34.1 5.2,34.6 5.2,34.6 15.8,45.3 30.5,60 35.7,54.8 21,40.1 10.3,29.5 20.4,19.3 34.6,5.2 29.5,0  15.3,14.2 5.2,24.3 5.2,24.3 4.8,24.6 0,29.5 0,29.5 " />
                                        </svg>
                                    </span>

                                    <span className="swiper-hero--next" id="press--swiper-hero--next">
                                        <svg version="1.1" x="0px" y="0px" viewBox="0 0 35.7 60">
                                            <polygon points="35.7,29.5 35.7,29.5 30.9,24.6 30.5,24.3 30.5,24.3 20.4,14.2 6.2,0 1.1,5.2 15.3,19.3 25.4,29.5 14.7,40.1 0,54.8 5.2,60 19.9,45.3 30.5,34.6 30.5,34.6 31,34.1 " />
                                        </svg>
                                    </span>
                                </div>

                            </Swiper>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
export default Quote;



// WEBPACK FOOTER //
// ./src/components/About/Press.js